import PropTypes from 'prop-types';
import React from 'react';

import styles from './legacy-footer-hover-menu.module.css';

const HOVER_DELAY = 100;

/** @deprecated Remove with the legacy AppFooter. */
export default class LegacyFooterHoverMenu extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    trigger: PropTypes.node.isRequired,
  };

  state = {
    active: false,
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleMouseEnter = () => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setState({ active: true });
    }, HOVER_DELAY);
  };

  handleMouseLeave = () => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setState({ active: false });
    }, HOVER_DELAY);
  };

  render() {
    return (
      <div
        className={styles.root}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {this.props.trigger}
        {this.state.active && (
          <div className={styles.content}>{this.props.children}</div>
        )}
      </div>
    );
  }
}
